import { useEffect, useState } from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { Input } from "../../../../Input/Input";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";
import { decryptPW, encryptPW } from "../../../../../ApiTS/ApiCommonTS";
import RadioBtn from "../../../../Button/RadioBtn";

interface Props extends DefaultModalCommonProps {
  partyId: number;
  uid: number;
  shareid: string;
  extrainfo: string;
  linkidmail?: string;
}

export default function ExtrainfoChangeModal({
  closeEvent,
  confirmEvent,
  partyId,
  uid,
  shareid,
  extrainfo,
  linkidmail,
}: Props) {
  const [reset, setReset] = useState(false);

  const parsedExtraInfo = () => {
    if (extrainfo) {
      return JSON.parse(extrainfo);
    }
  };

  const [new_extraInfo, setNew_extraInfo] = useState({
    name: parsedExtraInfo()?.name,
    mbrPW: (decryptPW(parsedExtraInfo()?.mbrPW, uid) || "").replaceAll('"', ""),
    country:parsedExtraInfo()?.country
  });

  const { response, loading, error } = useApi({
    method: "post",
    url: reset ? `party/updateInfo` : "",
    data: {
      partyid: partyId,
      uid: uid,
      extrainfo: JSON.stringify({
        ...new_extraInfo,
        mbrPW: encryptPW(new_extraInfo?.mbrPW, uid),
      }),
      reason: "extrainfo_change",
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("추가 정보가 변경 되었습니다.");
      if (confirmEvent) confirmEvent();
      closeEvent();
    }
  }, [response]);

  // useEffect(() => {
  //   if (error) {
  //     toast.error(error?.data ?? "비밀번호 재설정에 실패했습니다.");
  //     setReset(false);
  //   }
  // }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={closeEvent}
      confirmEvent={() => {
        setReset(true);
      }}
      isLargeModal
      modalTitle="계정 변경하기"
      confirmDisabled={false}
    >
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>현재 이름</ModalLabel>

        <ModalRowContentContainer style={{ flex: 1 }}>
          <ModalLabel style={{ marginLeft: 20 }}>
            {parsedExtraInfo()?.name}
          </ModalLabel>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>변경 이름</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <Input
            placeholder="변경할 이름을 입력해 주세요"
            value={new_extraInfo.name}
            onChange={(e) =>
              setNew_extraInfo({ ...new_extraInfo, name: e.target.value })
            }
          />
        </ModalRowContentContainer>
      </ModalRow>

      <div
        style={{ height: 2, width: "100%", backgroundColor: "#8b8b8b" }}
      ></div>

      {/* dd */}
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>현재 티빙 비밀번호</ModalLabel>

        <ModalRowContentContainer style={{ flex: 1 }}>
          <ModalLabel style={{ marginLeft: 20 }}>
            {(decryptPW(parsedExtraInfo()?.mbrPW, uid) || "").replaceAll('"', "")}
          </ModalLabel>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>변경 티빙 비밀번호</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <Input
            placeholder="변경할 티빙 비밀번호를 입력해 주세요"
            value={new_extraInfo.mbrPW}
            onChange={(e) =>
              setNew_extraInfo({ ...new_extraInfo, mbrPW: e.target.value })
            }
          />
        </ModalRowContentContainer>
      </ModalRow>

      <div
        style={{ height: 2, width: "100%", backgroundColor: "#8b8b8b" }}
      ></div>

      {/* dd */}
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>현재 국가</ModalLabel>

        <ModalRowContentContainer style={{ flex: 1 }}>
          <ModalLabel style={{ marginLeft: 20 }}>
            {parsedExtraInfo()?.country}
          </ModalLabel>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>변경 국가</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <Input
            placeholder="변경할 국가를 입력해 주세요"
            value={new_extraInfo.country}
            onChange={(e) =>
              setNew_extraInfo({ ...new_extraInfo, country: e.target.value })
            }
          />
        </ModalRowContentContainer>
      </ModalRow>

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
